import { render, staticRenderFns } from "./NewsCreate.vue?vue&type=template&id=ccae757c&scoped=true"
import script from "./NewsCreate.vue?vue&type=script&lang=js"
export * from "./NewsCreate.vue?vue&type=script&lang=js"
import style0 from "./NewsCreate.vue?vue&type=style&index=0&id=ccae757c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccae757c",
  null
  
)

export default component.exports